export default "__VITE_ASSET__CunAkrKG__"